import axios from '@axios'

export default {
    namespaced: true,
    state: {
        usuarios: [],
        tipoDocumento: [],
        tipoDocumentoEmitido: [],
        estabPorUsuario: [],
        carpetas: [],
        masters: [],
        documentos: [],
        carpetasEstructura: [],
        //seccBodPorUsuario:[],
        departamentos: [],
        bodegas: [],
        bodegasxEstab: [],
        estabConBodega: [], //estab con bodegas y secciones de bodega
        departPorEstab: [],
        departPorSeccBod: [],
        archivadorPorNombre: [],
        bodegasEstructArchivos: [],
        seccBodegaxIdBodega: [],
        descargarDocumento: [],
        configTipoDocumento: [], //configuracion
        usuariosTipoDocumento: [],
        configEstablecimiento: [],
        usuariosEstablecimiento: [],
        configDepartamento: [],
        usuariosDepartamento: [],
        configDepartamentosxEstab: [],
        configBodega: [],
        configBodegasxEstab: [],
        usuariosBodega: [],
        usuariosSeccBodega: [],
        configSeccBodega: [],
        configSeccBodegasxBodega: [],
        usuariosDocumento: [],
        configDocumento: [],
    },
    getters: {
        getUsuarios(state) {
            return state.usuarios
        },
        getTipoDocumento(state) {
            return state.tipoDocumento
        },
        getTipoDocumentoEmitido(state) {
            return state.tipoDocumentoEmitido
        },
        getEstabPorUsuario(state) {
            return state.estabPorUsuario
        },
        getMasters(state) {
            return state.masters
        },
        getCarpetas(state) {
            return state.carpetas
        },
        getDocumentos(state) {
            return state.documentos
        },
        getCarpetasEstructura(state) {
            return state.carpetasEstructura
        },
        getSeccBodegaPorUsuario(state) {
            return state.seccBodPorUsuario
        },
        getDepartamentos(state) {
            return state.departamentos
        },
        getBodegas(state) {
            return state.bodegas
        },
        getBodegasxEstab(state) {
            return state.bodegasxEstab
        },
        getEstablecimientosConBodega(state) {
            return state.estabConBodega
        },
        getDepartamentosPorEstab(state) {
            return state.departPorEstab
        },
        getDepartSeccBodega(state) {
            return state.departPorSeccBod
        },

        getArchivadorPorNombre(state) {
            return state.archivadorPorNombre
        },
        getBodegasEstructArchivos(state) {
            return state.bodegasEstructArchivos
        },
        getSeccBodegaxIdBodega(state) {
            return state.seccBodegaxIdBodega
        },
        getDescargarDocumento(state) {
            return state.descargarDocumento
        },
        getConfigTipoDocumento(state) {
            return state.configTipoDocumento
        },
        getUsuariosTipoDocumento(state) {
            return state.usuariosTipoDocumento
        },
        getConfigEstablecimiento(state) {
            return state.configEstablecimiento
        },
        getUsuariosEstablecimiento(state) {
            return state.usuariosEstablecimiento
        },
        getConfigDepartamento(state) {
            return state.configDepartamento
        },
        getUsuariosDepartamento(state) {
            return state.usuariosDepartamento
        },
        getConfigDepartamentosxEstab(state) {
            return state.configDepartamentosxEstab
        },
        getConfigBodega(state) {
            return state.configBodega
        },
        getConfigBodegasxEstab(state) {
            return state.configBodegasxEstab
        },
        getUsuariosBodega(state) {
            return state.usuariosBodega
        },
        getUsuariosSeccBodega(state) {
            return state.usuariosSeccBodega
        },
        getConfigSeccBodega(state) {
            return state.configSeccBodega
        },
        getConfigSeccBodegasxBodega(state) {
            return state.configSeccBodegasxBodega
        },
        getUsuariosDocumento(state) {
            return state.usuariosDocumento
        },
        getConfigDocumento(state) {
            return state.configDocumento
        },




    },
    mutations: {
        SET_USUARIOS(state, usuarios) {
            state.usuarios = usuarios
        },
        SET_TIPODOCUMENTO(state, tipoDocumento) {
            state.tipoDocumento = tipoDocumento
        },
        SET_TIPODOCUMENTOEMITIDO(state, tipoDocumentoEmitido) {
            state.tipoDocumentoEmitido = tipoDocumentoEmitido
        },
        SET_ESTABPORUSUARIO(state, estabPorUsuario) {
            state.estabPorUsuario = estabPorUsuario
        },
        SET_MASTERS(state, masters) {
            state.masters = masters
        },
        SET_CARPETAS(state, carpetas) {
            state.carpetas = carpetas
        },
        SET_DOCUMENTOS(state, documentos) {
            state.documentos = documentos
        },
        SET_CARPETASESTRUCTURA(state, carpetasEstructura) {
            state.carpetasEstructura = carpetasEstructura
        },
        /*SET_SECCBODPORUSUARIO(state, seccBodPorUsuario) {
            state.seccBodPorUsuario = seccBodPorUsuario
        },*/
        SET_DEPARTAMENTOS(state, departamentos) {
            state.departamentos = departamentos
        },
        SET_BODEGAS(state, bodegas) {
            state.bodegas = bodegas
        },
        SET_BODEGASESTABLEC(state, bodegasxEstab) {
            state.bodegasxEstab = bodegasxEstab
        },
        SET_ESTABCONBODEGA(state, estabConBodega) {
            state.estabConBodega = estabConBodega
        },
        SET_DEPARTPORESTAB(state, departPorEstab) {
            state.departPorEstab = departPorEstab
        },
        SET_DEPARTSECCBOD(state, departPorSeccBod) {
            state.departPorSeccBod = departPorSeccBod
        },
        SET_ARCHIVADORPORNOMBRE(state, archivadorPorNombre) {
            state.archivadorPorNombre = archivadorPorNombre
        },
        SET_BODEGASESTRUCTARCHIVOS(state, bodegasEstructArchivos) {
            state.bodegasEstructArchivos = bodegasEstructArchivos
        },
        SET_SECCBODEGAXIDBODEGA(state, seccBodegaxIdBodega) {
            state.seccBodegaxIdBodega = seccBodegaxIdBodega
        },
        SET_DescargarDocumentos(state, descargarDocumento) {
            state.descargarDocumento = descargarDocumento
        },
        SET_ConfigTipoDocumento(state, configTipoDocumento) {
            state.configTipoDocumento = configTipoDocumento
        },
        SET_UsuariosTipoDocumento(state, usuariosTipoDocumento) {
            state.usuariosTipoDocumento = usuariosTipoDocumento
        },
        SET_configEstablecimiento(state, configEstablecimiento) {
            state.configEstablecimiento = configEstablecimiento
        },
        SET_UsuariosEstablecimiento(state, usuariosEstablecimiento) {
            state.usuariosEstablecimiento = usuariosEstablecimiento
        },
        SET_configDepartamento(state, configDepartamento) {
            state.configDepartamento = configDepartamento
        },
        SET_UsuariosDepartamento(state, usuariosDepartamento) {
            state.usuariosDepartamento = usuariosDepartamento
        },
        SET_configDepartamentosxEstab(state, configDepartamentosxEstab) {
            state.configDepartamentosxEstab = configDepartamentosxEstab
        },
        SET_configBodega(state, configBodega) {
            state.configBodega = configBodega
        },
        SET_configBodegasxEstab(state, configBodegasxEstab) {
            state.configBodegasxEstab = configBodegasxEstab
        },
        SET_usuariosBodega(state, usuariosBodega) {
            state.usuariosBodega = usuariosBodega
        },
        SET_usuariosSeccBodega(state, usuariosSeccBodega) {
            state.usuariosSeccBodega = usuariosSeccBodega
        },
        SET_configSeccBodega(state, configSeccBodega) {
            state.configSeccBodega = configSeccBodega
        },
        SET_configSeccBodegasxBodega(state, configSeccBodegasxBodega) {
            state.configSeccBodegasxBodega = configSeccBodegasxBodega
        },
        SET_usuariosDocumento(state, usuariosDocumento) {
            state.usuariosDocumento = usuariosDocumento
        },
        SET_configDocumento(state, configDocumento) {
            state.configDocumento = configDocumento
        },




    },
    actions: {
        fetchUsuarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get("/api/auth/almacenDocumentos/usuarios")
                    .then((response) => {
                        commit('SET_USUARIOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchTipoDocumento({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/tipoDocumento')
                    .then((response) => {
                        commit('SET_TIPODOCUMENTO', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchTipoDocumentoEmitido({ commit }, emitido) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/tipoDocumentoEmitido/${emitido}`)
                    .then((response) => {
                        commit('SET_TIPODOCUMENTOEMITIDO', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchEstabPorUsuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/estabPorUsuario')
                    .then((response) => {
                        commit('SET_ESTABPORUSUARIO', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchCarpetas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/carpetas')
                    .then((response) => {
                        commit('SET_CARPETAS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchMasters({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/masters')
                    .then((response) => {
                        commit('SET_MASTERS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        fetchDocumentos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/documentos')
                    .then((response) => {
                        commit('SET_DOCUMENTOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchCarpetasEstructura({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/carpetasEstructura')
                    .then((response) => {
                        commit('SET_CARPETASESTRUCTURA', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchSeccBodegaEstructura({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/seccBodegaEstructArchivos')
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        fetchSeccBodegaxIdBodega({ commit }, idBodega) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/seccBodegaxIdBodega/${idBodega}`)
                    .then((response) => {
                        commit('SET_SECCBODEGAXIDBODEGA', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchArchivadorEstructura({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/archivadorEstructArchivos')
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        /*fetchSeccBodPorUsuario({ commit },establecId) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/seccBodPorUsuario/${establecId}`)
                    .then((response) => {
                        commit('SET_SECCBODPORUSUARIO', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },*/

        postCrearCarpeta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearCarpeta', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error.message);
                    })
            })
        },

        postCrearMaster({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearMaster', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error.message);

                    })
            })
        },

        postSubirDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/subirDocumentos', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postTransferirDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/transferirDocumento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchDescargarDocumentos({ commit }, data) {
            return new Promise((resolve, reject) => {
                var link = '/api/auth/almacenDocumentos/descargarDocumento'
                axios({ method: 'post', url: link, responseType: 'blob', data: data })
                    .then((response) => {
                        commit('SET_DescargarDocumentos', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },



        fetchBodegaEstrucArchivos({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/bodegasEstructArchivos`)
                    .then((response) => {
                        commit('SET_BODEGASESTRUCTARCHIVOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        //MANTENIMIENTO

        postCrearTipoDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearTipoDocumento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEditarTipoDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/editarTipoDocumento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEliminarTipoDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/eliminarTipoDocumento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearEstablecimiento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        postEditarEstablec({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/editarEstablecimiento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEliminarEstab({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/eliminarEstablecimiento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        fetchDepartamento({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/departamentos`)
                    .then((response) => {
                        commit('SET_DEPARTAMENTOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearDepartamento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEditarDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/editarDepartamento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEliminarDepart({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/eliminarDepartamento', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchBodega({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/bodegas`)
                    .then((response) => {
                        commit('SET_BODEGAS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearBodega', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEditarBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/editarBodega', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        postEliminarBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/eliminarBodega', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchSeccBodega({ commit }, idBodega) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/seccionesBodega`)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchBodegasxEstab({ commit }, idEstablecimiento) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/bodegasEstab/${idEstablecimiento}`)
                    .then((response) => {
                        commit('SET_BODEGASESTABLEC', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        //establecimientos con bodega y secciones de bodega
        fetchEstablecimientosConBodega({ commit }, ) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/estabConBodega`)
                    .then((response) => {
                        commit('SET_ESTABCONBODEGA', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchDepartamentosPorEstab({ commit }, idEstablecimiento) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/departPorEstab/${idEstablecimiento}`)
                    .then((response) => {
                        commit('SET_DEPARTPORESTAB', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchDepartSeccBodega({ commit }, idEstablecimiento) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/departSeccBodega/${idEstablecimiento}`)
                    .then((response) => {
                        commit('SET_DEPARTSECCBOD', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearSeccionBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearSeccionBodega', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEditarSeccBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/editarSeccBodega', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        //TREEBROWSER
        fetchArchivadorPorNombre({ commit }, etiqueta) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/archivadorPorNombre/${etiqueta}`)
                    .then((response) => {
                        commit('SET_ARCHIVADORPORNOMBRE', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        postEliminarSeccBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/eliminarSeccBodega', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEnviarBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/enviarBodega', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEditarPermisos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/editarPermisos', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        //CONFIGURACION

        fetchConfigTipoDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configTipoDocumento`)
                    .then((response) => {
                        commit('SET_ConfigTipoDocumento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchUsuariosTipoDocumento({ commit }, idTipoDoc) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/usuariosTipoDocumento/${idTipoDoc}`)
                    .then((response) => {
                        commit('SET_UsuariosTipoDocumento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEstadoTipoDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/estadoTipoDocumento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearPermisoUsuarioTipoDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearPermisoUsuarioTipoDocumento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConfigEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configEstablecimiento`)
                    .then((response) => {
                        commit('SET_configEstablecimiento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchUsuariosEstablecimiento({ commit }, idEstab) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/usuariosEstablecimiento/${idEstab}`)
                    .then((response) => {
                        commit('SET_UsuariosEstablecimiento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearPermisoUsuarioEstablec({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearPermisoUsuarioEstablec', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEstadoEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/estadoEstablecimiento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConfigDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configDepartamento`)
                    .then((response) => {
                        commit('SET_configDepartamento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchUsuariosDepartamento({ commit }, idDepEstab) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/usuariosDepartamento/${idDepEstab}`)
                    .then((response) => {
                        commit('SET_UsuariosDepartamento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        fetchConfigDepartamentosxEstab({ commit }, idEstab) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configDepartamentosxEstab/${idEstab}`)
                    .then((response) => {
                        commit('SET_configDepartamentosxEstab', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearPermisoUsuarioDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearPermisoUsuarioDepartamento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEstadoDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/estadoDepartamento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConfigBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configBodega`)
                    .then((response) => {
                        commit('SET_configBodega', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConfigBodegasxEstab({ commit }, idEstab) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configBodegasxEstab/${idEstab}`)
                    .then((response) => {
                        commit('SET_configBodegasxEstab', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchUsuariosBodega({ commit }, idBodega) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/usuariosBodega/${idBodega}`)
                    .then((response) => {
                        commit('SET_usuariosBodega', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearPermisoUsuarioBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearPermisoUsuarioBodega', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEstadoBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/estadoBodega', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConfigSeccBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configSeccBodega`)
                    .then((response) => {
                        commit('SET_configSeccBodega', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },


        fetchUsuariosSeccBodega({ commit }, idSeccBodega) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/usuariosSeccBodega/${idSeccBodega}`)
                    .then((response) => {
                        commit('SET_usuariosSeccBodega', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConfigSeccBodegasxBodega({ commit }, idBodega) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configSeccBodegasxBodega/${idBodega}`)
                    .then((response) => {
                        commit('SET_configSeccBodegasxBodega', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearPermisoUsuarioSeccBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearPermisoUsuarioSeccBodega', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEstadoSeccBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/estadoSeccBodega', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchUsuariosDocumento({ commit }, idDocumento) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/usuariosDocumento/${idDocumento}`)
                    .then((response) => {
                        commit('SET_usuariosDocumento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConfigDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/almacenDocumentos/configDocumento`)
                    .then((response) => {
                        commit('SET_configDocumento', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postCrearPermisoUsuarioDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/crearPermisoUsuarioDocumento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postEstadoDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/almacenDocumentos/estadoDocumento', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        getEliminarDocumento({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/almacenDocumentos/eliminarDocumento')
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

    }
}